export default [
    [

        // MED QUESTIONS
        // GOLD QUESTIONS
        {   
            textOdpoved: "Gold is a very heavy element, so movies where they steal gold bars in ordinary sports bags is very deceptive. To compare the weights of gold, lead and water at the same volume, we can use liter milk cartons. 1 litre of milk, or 1 dm3, has almost the same mass as 1 litre of water, so 1 kilogram. If we wanted to represent the mass of 1 dm3 of lead, we would need 11 cartons of milk, and 1 dm3 of gold would weigh the same as 19 cartons of milk. So if you could only fit 20 gold bars in one bag it would weigh more than 380 kg, and that is very silly to carry in one hand.",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=_q1Xo5eIJoc",
            obrazok: "/assets/fyzika-au.jpg",
            team: "zlato",
            title: "Physics",
            otazka: "No one doubts that lead is heavy as hell. Is it true that gold is even much heavier and that its bulk weight is almost twice as much ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},

            ],
        }
    ],
    [
        {
            textOdpoved: "Gold is a very stable substance, it dissolves only in aqua regia, cyanides, but its reaction with mercury is interesting. Even ancient alchemists knew that when gold and mercury are combined, a new substance is formed - amalgam. When amalgam is heated above 300°C, the mercury evaporates and pure gold remains. ",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=TynMnMhwFKE",
            obrazok: "/assets/chemia-au.png",
            team: "zlato",
            title: "Chemistry",
            otazka: "Your parents' generation was still properly irresponsible in childhood. For example, when the mercury thermometer broke, they played with balls of brutally poisonous mercury as if it was the safest thing in the world. Could it be true that someone who had a gold ring on their finger might have been left shocked at times when the yellow ring suddenly became a silver ring ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},
            ],
        }
    ],
    [
        {
            textOdpoved: "Gold was one of the first materials to be recycled. Because of its colour and shine, it has always appealed to people and had value. Therefore, it is possible that if you have something golden in your home, it contains a bit of gold from some ancient treasure from Egypt, Greece, Rome, etc.",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=DPaScIhyWZk",
            obrazok: "/assets/ekonomika-au.jpg",
            team: "zlato",
            title: "Circular Economy",
            otazka: "Paper, iron, aluminium, copper, copper, glass and some plastics are known to be widely recycled. Is it true that gold is now a newcomer to recycling?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: false},
                    { answerText: "No", isCorrect: true},
            ],
        }
    ],
    [
        {   
            textOdpoved: "When medals are handed out at the Olympics, we say that this one won bronze, that one won silver and that one won gold. However, this is not entirely true. Whoever wins 3rd place does indeed get a medal made of bronze, whoever wins 2nd place gets a medal made of silver, but whoever wins the gold medal almost always actually gets a gold-plated silver medal. There have only been a couple of Olympics in history where the winner actually won a gold medal, and that was in 1904,1908 and 1912. A medal made of gold would have been very heavy, and gold is a precious element, so it is saved.",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=KN734HhuY7A",
            obrazok: "/assets/sport-au.jpg",
            team: "zlato",
            title: "Sport",
            otazka: "At the moment, this is what it looks like with Olympic medals: Bronze is from bronze, silver is from silver. Is the gold also made of gold ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: false},
                    { answerText: "No", isCorrect: true},
            ],
        }
    ],
    [
        {
            textOdpoved: "There is very little gold not only on Earth, but also in the universe in general, and that is why it is so rare. This is because heavy elements like gold are formed in very dramatic circumstances, such as a supernova explosion or a neutron star collision. These circumstances are necessary for gold to form because the heavy nuclei of an element like gold can only combine at temperatures of several million Kelvin and with the delivery of huge amounts of energy. Moreover, gold has an odd number of protons, which complicates its formation even more.",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=_fr-D27eyqI",
            team: "zlato",
            title: "Astronomy",
            obrazok: "/assets/astronomia-au.jpg",
            otazka: "That gold as an element in the universe is said to be formed under very dramatic circumstances in a supernova explosion, which goes some way to explaining its rarity in the universe and on Earth ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},
            ],
        }
    ],
    [
        {
            textOdpoved: "Gold was and is usually obtained by panning. In experiential education, children often learn about gold mining by having some sort of container with water, sand, stones and some small pieces of pyrite. They circle the whole thing, peering into the jar and looking for the little shiny piece of gold",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=_fr-D27eyqI",
            team: "zlato",
            title: "Education",
            obrazok: "/assets/vzdelavanie-au.jpg",
            otazka: "In the picture we see the mineral pyrite. In some of the experiential learning experiments, children were given rice bowls and pyrite, which is yellow in colour, was poured into the sand and the children dug. Was this the right analogy ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: false},
                    { answerText: "No", isCorrect: true},
            ],
        }
    ],
    [
        {   
            textOdpoved:"San Francisco is one of those cities that grew thanks to the so-called Gold Rush. In two years, the population grew by 2500%, thanks to the adventurers, prospectors, gold miners, and all those who wanted to get rich quick by panning for gold nuggets. ",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=73WLnVAXqJ0",
            team: "zlato",
            obrazok: "/assets/geografia-cu.jpg",
            title: "Geography",
            otazka: "Could it be true that this is a shot of a town whose mid 19th century population grew by 2500% in two years due to gold ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},
            ],
        }
    ],
    [
        {
            textOdpoved: "Gold is mainly used in electrical engineering on contacts that we do not want to corrode, as it protects against corrosion and is very stable. However, its electrical and thermal conductivity is not as great as that of copper or silver, so it would not be correct to say that gold has an important place in small electronics because of its conductivity. It is precisely because of its stability, inertness and durability",
            video: "nie",
            videourl: "",
            team: "zlato",
            title: "Electrical Technology",
            obrazok: "/assets/elektro-au.jpg",
            otazka: "Is there any truth to the statement that copper is a good electrical conductor, silver is even better, but gold is the best, which is why it is used in the finest electronics ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: false},
                    { answerText: "No", isCorrect: true},
            ],
        }
    ],
    [
        {
            textOdpoved: "In the jewellery trade we encounter gold that is white (silver), red, pink, greenish, blue or various shades of yellow. These different colours are due to gold being mixed with some other element. In the past, jewellery was made of pure gold, but it was very soft and heavy, so over time gold began to be mixed with copper (red or pink colour), palladium, nickel, manganese (white colour), silver, cadmium, copper (green colour), aluminium (purple colour), indium and gallium (blue colour). In addition to the altered properties, people liked the new colours and so the mixing of the elements with gold has continued. ",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=nj6DjJiuTh8",
            team: "zlato",
            title: "Metallurgy",
            obrazok: "/assets/elektrotechnika-cu.png",
            otazka: "However, in the jewellery trade we encounter gold that is white (silver), red, pink, greenish, blue or various shades of yellow. It is said that gold is also referred to as such: pure - 24 carat, white - 18 carat, yellow - 14 carat, green - 9 carat. Is this a true statement ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: false},
                    { answerText: "No", isCorrect: true},
            ],
        }
    ],
    [
        {
            textOdpoved: "When gilding statues, picture frames, altars and the like, gold leaf is used, which is so thin that one gram of gold makes a 1m2 sheet and must be applied with a brush made from the hairs of a squirrel's tail. The thickness of such a sheet is 500 atoms, so it cannot be caught in the hand, and moreover sunlight can shine through it at such a thickness.",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=PqfXRWrdgfQ",
            team: "zlato",
            title: "Art",
            obrazok: "/assets/umenie-au.jpg",
            otazka: "When gilding statues, picture frames, altars and the like, gold leaf is used, which is so thin that one gram of gold makes a 1m2 sheet and must be applied with a brush made from the hairs of a squirrel's tail. Is that right ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},
            ],
        }
    ],

   
    
//ZELEZO QUESTIONS
// KREMIK
    [
        {  
            textOdpoved: "Sandstone gates, arches, towers and other similar formations are creating all over the world as a result of wind erosion.  If we tried to help such formations by supporting them with pillars and the like, we would rather harm them and they would crumble. This is because the frictional force that holds the individual sandstone particles together would be reduced. ",
             video: "ano",
            videourl: "https://www.youtube.com/watch?v=Nnq7tORBLKE",
            team: "kremik",
            obrazok: "/assets/fyzika-si.jpg",
            title: "Physics",
            otazka: "As a result of wind erosion, sandstone gates, arches, towers and formations similar to the one in the picture are springing up all over the world. Is such an arch more likely to fall down if it is relieved (propped up) by some supporting structure, for example, in an attempt to save it?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},
            ],
        }
    ],
    [
        {   
            textOdpoved: "Silica is very similar to carbon in their ability to form chains and polymers, which are commonly used as silicone sealants in household caulking, as silicone cookware, and other practical things.  ",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=Iw-hAzHooUc",
            team: "kremik",
            obrazok: "/assets/chemia-si.jpg",
            title: "Chemistry",
            otazka: "Does silicon as an element have the ability to form polymer chains like carbon ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},
            ],
        }
    ],
    [
        {   
            textOdpoved: "Glass as a material made mainly of sand (SiO2) is intrinsically linked to with beverages. Wine, for example, is bottled for long-term preservation. This prevents the wine from coming into contact with the surrounding environment and also prevents oxidation.",
            video: "nie",
            videourl:"",
            team: "kremik",
            title: "Gastronomy",
            obrazok: "/assets/gastronomia-si.jpg",
            otazka: "Glass as a material made mainly of sand (SiO2) is intrinsically linked to beverages. Wine, for example, is bottled for long-term preservation. Is this because the silica reacts with some of the acids in the wine, making the wine become more delicate over time?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: false},
                    { answerText: "No", isCorrect: true},
            ],
        }
    ],
    [
        {
            textOdpoved: "Abrasives made from silicon-based materials are often used for metal grinding. The most durable material used for such grinding is silicon carbide SiC (grade 9-10 on the Mohs scale) known as carborundum.",
            video: "ano",
            videourl: "",
            team: "kremik",
            title: "Agriculture",
            obrazok: "/assets/polnohospodarstvo-si.jpg",
            otazka: "Abrasives made from silicon-based materials are often used for metal grinding. Of these silicon-based abrasives, is the hardest material silicon dioxide SiO2 (grade 7 on the Mohs scale)?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: false},
                    { answerText: "No", isCorrect: true},
            ],

        }
    ],
    [
        {
            textOdpoved: "Silicon is an element that is abundant in the Earth's crust, approximately 26-28%. However, its origins must be sought outside our Earth. It is formed in the cores of stars larger than our Sun. Many elements up to Fe are formed in this way.",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=L-XsqX-dqZM",
            team: "kremik",
            title: "Astronomy",
            obrazok: "/assets/astronomia-si.jpg",
            otazka: "Silicon is an element that is abundant in the Earth's crust. But its origins must be sought outside our Earth. Is it true that silicon, or its nuclei, are formed inside stars by nuclear fusion from magnesium and helium nuclei ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},
            ],
        }
    ],
    [
        {
            textOdpoved: "Quartz watch movements, which came into vogue in the 2nd half of the 20th century, power battery-powered watches, which are now much more widespread than the classic mechanical ones. The clock's tact is determined by the oscillator, which is a pulsating piezoelectric quartz crystal SiO2 powered by a battery. These watches no longer have that typical ticking. ",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=nexJ6m5eyqw",
            team: "kremik",
            obrazok: "/assets/hodinky-si.jpg",
            title: "Watch",
            otazka: "Quartz watch movements are powered by battery-powered watches, which are much more widespread today than the classic mechanical ones. Is the claim that the clock speed of a quartz watch movement is determined by a silicon semiconductor component such as a diode or transistor true?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: false},
                    { answerText: "No", isCorrect: true},
            ],
        }
    ],
    [
        {
            textOdpoved: "Albert Einstein is best known for his special and general theory of relativity, but he won the Nobel Prize for explaining the principle of the photovoltaic phenomenon, in which electrons are knocked out of atoms in some substances exposed to light. These electrons are then used to generate electricity using photovoltaic cells. Silicon is the most widely used material for their production. ",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=x8r3TXzNvXE",
            team: "kremik",
            title: "Personality",
            obrazok: "/assets/osobnosti-si.jpg",
            otazka: "Photovoltaic cells use the photoelectric phenomenon, in which electrons are knocked out of atoms in certain substances exposed to light. Is it true that Albert Einstein was awarded the Nobel Prize for explaining this phenomenon ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},
            ],
        }
    ],
    [
        {
            textOdpoved: "The vast majority of semiconductor electronic components are silicon.  However, this silicon is not made from metallic silicon, which is abundantly found in deposits buried deep in the Earth's crust, but the basic raw material for making silicon for semiconductor components is sand.",
            video: "ano",
            videourl: "https://www.youtube.com/watch?v=LXbdii9n8eM",
            team: "kremik",
            obrazok: "",
            title: "Information Technology",
            otazka: "The vast majority of semiconductor electronic components are silicon. Is it true to say that the basic raw material for their production is silicon metal, which is abundantly found in deposits deep in the Earth's crust?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},
            ],
        }
    ],
    [
        {
            textOdpoved: "In the old days, metal objects were made by casting them into moulds made of sand. Nowadays, this method is still used, for example, the engine blocks of high-end racing cars are made by casting them in sand moulds.",
            video: "nie",
            videourl: "",
            team: "kremik",
            title: "Engineering",
            obrazok: "/assets/stroje-si.jpg",
            otazka: "In the old days, metal objects were made by casting them into moulds made of sand. Is there any truth to the assertion that complex parts such as the engine blocks of modern cars can no longer be made in this way?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: false},
                    { answerText: "No", isCorrect: true},
            ],
        }
    ],
    [
        {
            textOdpoved: "Silicon is the second most abundant element in the Earth's crust after oxygen, mainly in the form of SiO2 and other compounds. It is a component of rocks such as sandstones, clays, granites. Almost pure silica is referred to as crystal, amethyst is coloured purple, citrine is yellow, rose quartz is pink, brown ginger and jasper, for example, comes in several shades of colour. A special case of a silica-based mineral is the amorphous form of this compound - opal. This fashionable semi-precious stone occurs in several colour shades.",
            team: "kremik",
            video: "ano",
            videourl: "",
            title: "Geology",
            obrazok: "/assets/geologia-si.jpg",
            otazka: "Silicon is one of the most common elements on earth. Is it true that silicon is abundant, especially in the Earth's crust, where its proportion is more than 25% ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},
            ],
        }
    ],
    [
        {
            textOdpoved: "",
            video: "ano",
            videourl: "",
            team: "kremik",
            title: "Zemepis",
            obrazok: "/assets/zemepis-fe.png",
            otazka: "V Európe majú niektoré obce a mestá názov spojený s remeslom mletia obilia, resp. mlynmi. Má na Slovensku niektoré okresné mesto názov podľa mlynského kameňa ?",
            moznostA: "Yes",
            moznostB: "No",
            answerOptions: [
                    { answerText: "Yes", isCorrect: true},
                    { answerText: "No", isCorrect: false},
            ],
        }
    ],
    

];